import {Brands} from "@/brand/brandConfig";

const VODACOM_BRANDS = [
    Brands.VodacomSouthAfricaEnglish,
    Brands.VodacomEvinaSouthAfricaEnglish,
];

export function isVodacomBrand(brand) {
    return VODACOM_BRANDS.includes(brand);
}
